var map = {
	"./site-logo-desktop-footer.svg": 82200,
	"./site-logo-desktop.svg": 50428,
	"./site-logo-drawer-mobile.svg": 94274,
	"./site-logo-drawer.svg": 8547,
	"./site-logo-mobile-drawer.svg": 9188,
	"./site-logo-mobile.svg": 26162,
	"./site-logo-sm.svg": 44048,
	"./site-logo-tv.svg": 93158,
	"./site-logo-wrapper-mobile-scrolled.svg": 5101,
	"./site-logo-wrapper-mobile.svg": 99944,
	"./site-logo-wrapper-scrolled.svg": 39490,
	"./site-logo-wrapper.svg": 80621
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2127;